import { useSearchParams } from 'react-router-dom'
import { Heading, LoadingSection } from '@quickmd-llc/design-system'
import { PageLayout } from 'components/page-layouts/PageLayout'
import { useProviderMedications } from './hooks/useProviderMedications'
import { MedicationListPanel } from './components/MedicationListPanel'
import { MedicationDetailPanel } from './components/MedicationDetailPanel'

export function MedicationsPage() {
  const [searchParams, setSearchParams] = useSearchParams()

  const selectedId = searchParams.get('selected')
  const search = searchParams.get('search') ?? ''

  const { data: medications, isLoading } = useProviderMedications()

  function updateParams(updates: Record<string, string | null>) {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev)
        for (const [key, value] of Object.entries(updates)) {
          if (value) {
            next.set(key, value)
          } else {
            next.delete(key)
          }
        }
        return next
      },
      { replace: true },
    )
  }

  const selectedMedication = (selectedId ? medications.find((m) => m.Id === selectedId) : null) ?? null

  return (
    <PageLayout>
      {/* Tailwind is scoped under `.tailwind-scoped` in provider (unlike admin, where
          it's global), so the whole medications tree must live inside this wrapper or
          none of the layout/token classes apply. Outer background/padding comes from
          PageLayout. */}
      <div className='tailwind-scoped' style={{ height: '100%' }}>
        <div className='grid h-full gap-sp-3 [grid-template-rows:auto_1fr]'>
          <div className='flex items-center justify-between'>
            <Heading level='h1'>Medications</Heading>
          </div>

          {/* 2-panel body */}
          <div className='flex min-h-0 flex-1 flex-col overflow-hidden'>
            {isLoading ?
              <LoadingSection />
            : <div className='grid h-full grid-cols-[304px_1fr] gap-sp-2'>
                <MedicationListPanel
                  medications={medications}
                  selectedId={selectedId}
                  search={search}
                  onSearchChange={(v) => updateParams({ search: v || null })}
                  onSelect={(med) => updateParams({ selected: med.Id })}
                />
                <MedicationDetailPanel selectedMedication={selectedMedication} />
              </div>
            }
          </div>
        </div>
      </div>
    </PageLayout>
  )
}
